import {EntityData, field, SearchModel} from "@fedelta-pos/data-client";
import {Injectable, Injector, inject} from "@angular/core";

export class MemberSalesData extends EntityData<MemberSalesData> {
    public static DELIVERY = 6;
    public static TAKEAWAY = 7;
    public static APP_AT_TABLE = 11;

    @field orderReceiptNo: string;
    @field saleReceiptNo: string;
    @field saleDate: Date;
    @field saleTotal: number;
    @field saleType: number;
    @field outletName: string;
    @field storeId: number;
    @field pointsAccrued: number;
    @field saleReceipt: string;
    @field customerRefNo: string;
}

/**
 * Search model to retrieve a list member sales
 */
@Injectable()
export class MemberSalesSearchModel extends SearchModel<MemberSalesData> {
    public override limit: number = 50;

    constructor() {
        super(inject(Injector));
        console.log("--- MemberSalesSearchModel");
    }
}
